export const SK_TOKEN = 'token';
export const SK_ORGANIZATION = 'organization';
export const SK_STOREFRONT = 'storefront';
export const SK_FIRST_NAME = 'firstName';
export const SK_LAST_NAME = 'lastName';
// Notification bars the shopper has closed: { [barId]: revisionDismissed }. Written to
// sessionStorage or localStorage depending on each bar's own dismissMode (see notificationsConfig).
export const SK_NOTIFICATIONS_DISMISSED = 'sf-notif-dismissed';